// extracted by mini-css-extract-plugin
module.exports = {"galleryWrapper":"style_galleryWrapper__1m64j","galleryItem":"style_galleryItem__1YN3n"};